import { checkPin, getFlag, getIp, submit, unSubscribe, subscribe } from './reminder.actions'
import { createSlice } from '@reduxjs/toolkit'

const INITIAL_STATE = {
  pinResponse: {},
  submitResponse: {},
  flagResponse: {},
  ipResponse: {},
  unSubscribeResponse: {},
  subscribeResponse: {},
}

const reminderSlice = createSlice({
  name: 'reminder',
  initialState: INITIAL_STATE,
  extraReducers: (builder) => {
    builder
      .addCase(checkPin.fulfilled, (state, action) => {
        state.pinResponse = action.payload
      })
      .addCase(submit.fulfilled, (state, action) => {
        state.submitResponse = action.payload
      })
      .addCase(getIp.fulfilled, (state, action) => {
        state.ipResponse = action.payload
      })
      .addCase(getFlag.fulfilled, (state, action) => {
        state.flagResponse = action.payload
      })
      .addCase(unSubscribe.fulfilled, (state, action) => {
        state.unSubscribeResponse = action.payload
      })
      .addCase(subscribe.fulfilled, (state, action) => {
        state.subscribeResponse = action.payload
      })
  },
})

const { reducer } = reminderSlice
export default reducer
